export const MAX_PAYER_NAME_LENGTH = 20;
